import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UtilsNpsService } from '../utils.service';
import { NpsMessageResponse } from 'src/app/shared/services/responses/nps/nps-message.reponse';
import { UtilService } from 'src/app/shared/services/util.service';
import { QRCode } from 'src/app/shared/services/models/totem/nps-message.model';

@Component({
  selector: 'app-end-nps',
  templateUrl: './end-nps.component.html',
  styleUrls: ['./end-nps.component.css']
})
export class EndNpsComponent implements OnInit {

  constructor(
    public router: Router,
    private utilsNpsService: UtilsNpsService,
    private utilService: UtilService,
  ) { }

  public npsMessageResponse: NpsMessageResponse;
  public qrCode: QRCode;

  public isLoading: boolean = false;
  
  public colorCode: string = "";

  ngOnInit(): void {
    this.npsMessageResponse = this.utilsNpsService.getNpsMessageResponse();
    this.qrCode = this.utilService.getQRCodeConfig();

    if (this.npsMessageResponse.npsScreenConfig.useColor) {
      this.colorCode = this.npsMessageResponse.npsScreenConfig.colorCode;
      document.documentElement.style.setProperty('--colorCodeNps', this.colorCode);
    }
  }

  goRedirectPage() {
    this.router.navigate([`welcome/redirect-page/${this.qrCode.guid}`]);
  }
}